import React, { Fragment, Component } from 'react';
import classNames from 'classnames';
import { queryString } from '../../utils';
import TextContent from '../textContent/TextContent';
import Loader from '../loader/Loader';
import QrCode from '../referralsForm/qrCode/QrCode';

const CheckboxElement = ({ name, className, label, value, change }) => {
  const componentClasses = classNames('sme-od-checkbox', {
    [`sme-od-checkbox-${className}`]: className
  });

  return (
    <div className={componentClasses}>
      <input checked={value} onChange={change} type="checkbox" name={name} id={`${name}`} />
      <label id={`${name}-label`} htmlFor={`${name}`}>
        {label}
      </label>
    </div>
  );
};

const InputElement = (props) => {
  const { name, type, label, required, className, change, value } = props;
  if (type === 'checkbox') {
    return <CheckboxElement value={value} change={change} {...props} />;
  }

  const componentClasses = classNames('sme-od-label', {
    'sme-od-label--required': required,
    'sme-od-label--hidden': type === 'hidden'
  });

  return (
    <Fragment>
      <label id={`${name}-label`} htmlFor={name} className={componentClasses}>
        {label}
      </label>
      <input
        type={`${type || 'text'}`}
        name={name}
        id={name}
        placeholder={props.placeholder || null}
        title={props.title || null}
        onChange={change}
        value={value}
        required={required ? true : false}
        className={`${className || 'sme-od-input'}`}
      />
    </Fragment>
  );
};

const referralsFormData = {
  businessName: {
    name: 'businessName',
    type: 'text',
    label: 'What is your business name or trading name?',
    placeholder: '',
    required: true
  },
  phoneNumber: {
    name: 'phoneNumber',
    type: 'tel',
    label: 'Mobile number (please use the same number that you’ll open an account with)',
    placeholder: '07700 90000',
    required: true
  },
  marketingConsent: {
    name: 'marketingConsent',
    type: 'checkbox',
    label:
      'We’d love to let you know about our products, Starling news and offers via email. Please tick this box if you are happy for us to do so. You may withdraw your consent at any time by following the unsubscribe link.'
  },
  referralCode: { name: 'referralCode', type: 'hidden', label: 'Referral Code', placeholder: '', required: true }
};

class ReferralsFormAccountants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      businessName: '',
      phoneNumber: '',
      marketingConsent: false,
      referralCode: '',
      error: false,
      errorMsg: 'Sorry about that! Please try again in a few minutes.',
      success: false,
      validation: [],
      loading: false
    };
    this.formElement = React.createRef(); // Create a ref object
  }

  componentDidMount() {
    var params = queryString(window.location.search);

    if (params.creative_id) {
      this.setState({
        referralCode: params.creative_id
      });
    } else {
      this.setState({
        error: true,
        errorMsg:
          'It looks like you haven’t got a referral code. Easily sorted: ask your accountant for their referral link, and then come back to this page.'
      });
    }
  }

  handleInputChange(e) {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const data = Object.assign({}, this.state);
    let validation = [];

    let numberRegex = /^\+?\d+(#\d+)?$/;
    if (!numberRegex.test(data.phoneNumber)) {
      validation.push('Mobile Phone Number is invalid');
    }

    if (validation.length) {
      this.setState({
        validation
      });
    } else if (validation.length === 0 && typeof window !== 'undefined') {
      this.formElement.current.scrollIntoView({ behavior: 'smooth' });
      this.setState({ loading: true });
      const grecaptcha = window.grecaptcha;
      const grecaptchaKey = window.starlingbank.getConfig('grecaptchaKey');
      const FORM_URL = window.starlingbank.getConfig('referralsFormAccountants');

      grecaptcha.ready(() => {
        grecaptcha.execute(grecaptchaKey, { action: 'submit' }).then((token) => {
          const body = {
            businessName: data.businessName,
            phoneNumber: data.phoneNumber,
            marketingConsent: data.marketingConsent,
            referralCode: data.referralCode,
            recaptchaResponseToken: token
          };

          const payload = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          };

          fetch(FORM_URL, payload)
            .then((response) => {
              this.setState({ loading: false });
              if (response.status === 202) {
                this.setState({
                  error: false,
                  success: true
                });
              } else if (response.status === 403) {
                response.text().then((text) => {
                  if (text === 'RECAPTCHA_VERIFICATION_FAILED') {
                    this.setState({
                      error: true,
                      errorMsg: 'Google ReCAPTCHA invalid, please try again later.'
                    });
                  }
                });
              } else if (response.status === 404) {
                this.setState({
                  error: true,
                  errorMsg:
                    'It looks like the URL you used isn’t working. Is it definitely the one your accountant sent you? Please check by clicking the link again – or ask them for a new link.'
                });
              } else if (response.status === 400) {
                response.json().then((res) => {
                  let responseMsg = res[0];
                  if (responseMsg === 'PHONE_NUMBER_INVALID') {
                    validation.push('Mobile number is invalid, please check you entered the correct details.');
                    this.setState({ validation });
                  } else if (responseMsg === 'ERROR_RECORDING_REFERRAL') {
                    this.setState({
                      error: true,
                      errorMsg: 'Sorry about that! Please try again in a few minutes.'
                    });
                  } else {
                    this.setState({
                      error: true,
                      errorMsg: responseMsg
                    });
                  }
                });
              }
            })
            .catch((error) => {
              this.setState({
                error: true,
                errorMsg: 'Sorry about that! Please try again in a few minutes.',
                loading: false
              });
            });
        });
      });
    }
  }

  render() {
    return (
      <section className="section section--no-padding-top" ref={this.formElement} id="referral-form">
        {this.state.loading && <Loader />}
        {this.state.success ? (
          <div>
            <h2 className="text-content text-content__inner">Apply for an award-winning business account today</h2>
            <QrCode type="accountancy" />
          </div>
        ) : (
          <></>
        )}
        {!this.state.error && !this.state.success && !this.state.loading ? (
          <Fragment>
            <h2 className="sme-od-form-title">
              We're excited to welcome clients of {this.state.referralCode.replace(/_/g, ' ')}
            </h2>
            <p className="sme-od-form-title">
              Complete some details below. Make sure to use the contact details you'll use to open the business account
              with.
            </p>
            <form
              method="POST"
              onSubmit={(e) => this.handleSubmit(e)}
              className="form-business-registration sme-od-form show"
            >
              {Object.keys(referralsFormData).map((f) => (
                <InputElement
                  value={this.state[f]}
                  change={this.handleInputChange.bind(this)}
                  key={f}
                  {...referralsFormData[f]}
                />
              ))}
              <p>
                See our{' '}
                <a href="/legal/privacy-notice/" target="_blank">
                  Privacy Notice
                </a>{' '}
                for how we process your personal data.
              </p>
              {this.state.validation.length ? (
                <ul className="sme-od-validation-errors">
                  {this.state.validation.map((item) => {
                    return <li key={item}>{item}</li>;
                  })}
                </ul>
              ) : null}
              <div className="sme-od-form-actions">
                <button className="sme-od-submit-button" type="submit" name="submit">
                  Submit details
                </button>
              </div>
              <small>
                This form is protected by reCAPTCHA and both the Google{' '}
                <a href="https://policies.google.com/terms?hl=en" target="_blank" rel="noopener noreferrer">
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>{' '}
                apply.
              </small>
            </form>
          </Fragment>
        ) : null}
        {this.state.error && (
          <Fragment>
            <TextContent customPadding="no-bottom">
              <div className="text-content__inner">
                <h2>Hmm. Something's not quite right.</h2>
                <p>
                  <strong>{this.state.errorMsg}</strong>
                </p>
              </div>
            </TextContent>
          </Fragment>
        )}
      </section>
    );
  }
}

export default ReferralsFormAccountants;
